module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-modal', {
    ref: "addPayment",
    attrs: {
      "hide-footer": "",
      "title": "Dodaj wpłatę"
    }
  }, [(_vm.paymentLoading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.selectedInvoice && !_vm.paymentLoading) ? _c('form-payment', {
    ref: "addPaymentForm",
    attrs: {
      "currencyName": _vm.invoiceCurrency,
      "handleSubmit": _vm.handlePayment,
      "values": _vm.paymentData,
      "errors": _vm.paymentViolations
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.paymentLoading) ? _c('b-row', [_c('b-col', [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "block": ""
    },
    on: {
      "click": _vm.hideAddPaymentModal
    }
  }, [_c('span', [_vm._v("Anuluj")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "back"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "default",
      "block": ""
    },
    on: {
      "click": _vm.sendPaymentForm
    }
  }, [_c('span', [_vm._v("Zapisz")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "tick"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('page-title', [_c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'FactoredInvoiceList'
      }
    }
  }, [_vm._v("Faktury zakupione")])], 1)]), _vm._v(" "), _c('b-container', {
    staticClass: "col page-element"
  }, [(_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.createdPaymentMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("Płatność w kwocie " + _vm._s(_vm.createdPaymentMessage) + " została dodana")]) : _vm._e(), _vm._v(" "), (_vm.deletedItem) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v(_vm._s(_vm.deletedItem['@id']) + " deleted.")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_c('thead', [_c('tr', [_c('td', [_c('b-form-input', {
    staticClass: "form-control input-search",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.filter.number),
      callback: function($$v) {
        _vm.$set(_vm.filter, "number", $$v)
      },
      expression: "filter.number"
    }
  }), _c('svg-icon', {
    attrs: {
      "name": "search"
    }
  })], 1), _vm._v(" "), _c('td', [_c('date-range-picker', {
    attrs: {
      "pickerClass": "two-rows"
    },
    model: {
      value: (_vm.selectedCreateDatePeriod),
      callback: function($$v) {
        _vm.selectedCreateDatePeriod = $$v
      },
      expression: "selectedCreateDatePeriod"
    }
  })], 1), _vm._v(" "), _c('td', [_c('date-range-picker', {
    attrs: {
      "pickerClass": "two-rows"
    },
    model: {
      value: (_vm.selectedPaymentDatePeriod),
      callback: function($$v) {
        _vm.selectedPaymentDatePeriod = $$v
      },
      expression: "selectedPaymentDatePeriod"
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    staticClass: "form-control input-search",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.filter.debtor),
      callback: function($$v) {
        _vm.$set(_vm.filter, "debtor", $$v)
      },
      expression: "filter.debtor"
    }
  }), _c('svg-icon', {
    attrs: {
      "name": "search"
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    staticClass: "form-control input-search",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.filter['agreement.fullNumber']),
      callback: function($$v) {
        _vm.$set(_vm.filter, 'agreement.fullNumber', $$v)
      },
      expression: "filter['agreement.fullNumber']"
    }
  }), _c('svg-icon', {
    attrs: {
      "name": "search"
    }
  })], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('dropdown-search', {
    attrs: {
      "id": "status-dropdown",
      "elements": _vm.currencyTypes,
      "nameField": "name",
      "showEmpty": true,
      "valueField": "id"
    },
    model: {
      value: (_vm.filter['agreement.currency']),
      callback: function($$v) {
        _vm.$set(_vm.filter, 'agreement.currency', $$v)
      },
      expression: "filter['agreement.currency']"
    }
  })], 1), _vm._v(" "), _c('td', [_c('dropdown-search', {
    attrs: {
      "id": "status-dropdown",
      "elements": _vm.statusLists,
      "showEmpty": true,
      "nameField": "name",
      "valueField": "value"
    },
    model: {
      value: (_vm.selectedStatus),
      callback: function($$v) {
        _vm.selectedStatus = $$v
      },
      expression: "selectedStatus"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "no-wrap"
  }, [_c('my-button', {
    attrs: {
      "variant": "info",
      "action": _vm.getItems
    }
  }), _vm._v(" "), _c('my-button', {
    attrs: {
      "icon": "back",
      "variant": "primary",
      "action": _vm.resetFilter
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('number'),
    on: {
      "click": function($event) {
        return _vm.setOrder('number')
      }
    }
  }, [_vm._v("Numer")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('createDate'),
    on: {
      "click": function($event) {
        return _vm.setOrder('createDate')
      }
    }
  }, [_vm._v("Data wystawienia")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('paymentDate'),
    on: {
      "click": function($event) {
        return _vm.setOrder('paymentDate')
      }
    }
  }, [_vm._v("Termin zapłaty")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('debtorData.name'),
    on: {
      "click": function($event) {
        return _vm.setOrder('debtorData.name')
      }
    }
  }, [_vm._v("Dłużnik")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('agreement.fullNumber'),
    on: {
      "click": function($event) {
        return _vm.setOrder('agreement.fullNumber')
      }
    }
  }, [_vm._v("Umowa")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('amount'),
    on: {
      "click": function($event) {
        return _vm.setOrder('amount')
      }
    }
  }, [_vm._v("Kwota")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('leftToPaid'),
    on: {
      "click": function($event) {
        return _vm.setOrder('leftToPaid')
      }
    }
  }, [_vm._v("Do zapłaty")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('agreement.currency.name'),
    on: {
      "click": function($event) {
        return _vm.setOrder('agreement.currency.name')
      }
    }
  }, [_vm._v("Waluta")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementUpdate',
          params: {
            id: item.agreement.id,
            tab: 'invoice'
          }
        }
      }
    }, [_vm._v(_vm._s(item['number']))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementUpdate',
          params: {
            id: item.agreement.id,
            tab: 'invoice'
          }
        }
      }
    }, [_vm._v(_vm._s(_vm._f("date")(item['createDate'])))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementUpdate',
          params: {
            id: item.agreement.id,
            tab: 'invoice'
          }
        }
      }
    }, [_vm._v(_vm._s(_vm._f("date")(item['paymentDate'])))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementUpdate',
          params: {
            id: item.agreement.id,
            tab: 'invoice'
          }
        }
      }
    }, [_vm._v(_vm._s(item['debtorData']['name']) + ", NIP: " + _vm._s(item['debtorData']['nip']))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementUpdate',
          params: {
            id: item.agreement.id,
            tab: 'invoice'
          }
        }
      }
    }, [_vm._v(_vm._s(item['agreement']['fullNumber']))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementUpdate',
          params: {
            id: item.agreement.id,
            tab: 'invoice'
          }
        }
      }
    }, [_vm._v(_vm._s(item['amount']))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementUpdate',
          params: {
            id: item.agreement.id,
            tab: 'invoice'
          }
        }
      }
    }, [_vm._v(_vm._s(item['leftToPaid']))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementUpdate',
          params: {
            id: item.agreement.id,
            tab: 'invoice'
          }
        }
      }
    }, [_vm._v(_vm._s(item['agreement']['currency']['name']))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementUpdate',
          params: {
            id: item.agreement.id,
            tab: 'invoice'
          }
        }
      }
    }, [(item['paid']) ? _c('span', {
      staticClass: "element_status closed"
    }, [_vm._v("Zapłacona")]) : _vm._e(), _vm._v(" "), (!item['paid'] && !item['deducted']) ? _c('span', {
      staticClass: "element_status open"
    }, [_vm._v("Niezapłacona")]) : _vm._e(), _vm._v(" "), (item['deducted']) ? _c('span', {
      staticClass: "element_status deducted"
    }, [_vm._v("Potrącona")]) : _vm._e(), _vm._v(" "), (item['returned']) ? _c('span', {
      staticClass: "element_status returned"
    }, [_vm._v("Zwrócona")]) : _vm._e()])], 1), _vm._v(" "), _c('td')])
  }), 0)])]), _vm._v(" "), _c('pagination', {
    attrs: {
      "changePage": _vm.changePage,
      "currentPage": _vm.currentPage,
      "pagination": _vm.pagination
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a02aca0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/factoredinvoice/List.vue
// module id = 806
// module chunks = 0